import { TextDisplayElementModel } from '../../../Common/PageBuilder/models/text-display-element.model';
import { MonitoringTextStyleModel } from '../../Shared/models/monitoring-text-style.model';

export class BriefingTextDisplayElementModel extends TextDisplayElementModel {

    enablePersonalizations: boolean = false;
    enableLineHeight: boolean = true;
    enableHeading: boolean = true;
    enableFontColor: boolean = true;
    enableBackgroundColor: boolean = true;
    enableHtmlEditor: boolean = true;
    enableFontFamily: boolean = true;
    enableFontSize: boolean = true;
    enableAlignment: boolean = true;
    enableInsertImage: boolean = true;
    enableStrikethrough: boolean = true;
    enableNumberedList: boolean = true;
    enableBlockQuote: boolean = true;
    enableDirection: boolean = true;
    enableIndent: boolean = true;
    pastePlainText: boolean = false;
    enableAIRefinement: boolean = false;

    cachedText: string;

    constructor(
        content?: string,
        styles?: any,
    ) {
        super(content, styles);

        this.styles = new MonitoringTextStyleModel(styles);
    }

    clone(clone?: BriefingTextDisplayElementModel): BriefingTextDisplayElementModel {
        if (!clone) {
            clone = new BriefingTextDisplayElementModel(
                this.text,
                this.styles && this.styles.clone ? this.styles.clone() : JSON.parse(JSON.stringify(this.styles))
            );
        }
        clone.enablePersonalizations = this.enablePersonalizations;
        clone.enableLineHeight = this.enableLineHeight;
        clone.enableFontColor = this.enableFontSize;
        clone.enableBackgroundColor = this.enableBackgroundColor;
        clone.enableHtmlEditor = this.enableHtmlEditor;
        clone.enableFontFamily = this.enableFontFamily;
        clone.enableFontSize = this.enableFontSize;
        clone.enableInsertImage = this.enableInsertImage;
        clone.enableStrikethrough = this.enableStrikethrough;
        clone.enableNumberedList = this.enableNumberedList;
        clone.enableBlockQuote = this.enableBlockQuote;
        clone.pastePlainText = this.pastePlainText;
        clone.enableAIRefinement = this.enableAIRefinement;

        return clone;
    }
}
